/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div class="row">
    <div
      id="stats"
      class="col-sm-10"
    >
      <div
        v-for="stat in stats"
        :key="stat.name"
        class="stat"
        :class="[ 'col-xs-' + Math.floor(10 / stats.length) ]"
      >
        <div :class="stat.statClass">
          {{ stat.value }}
          <small v-if="stat.subtext">
            {{ stat.subtext }}
          </small>
        </div>
        <div class="stat-name">
          {{ stat.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  #stats .stat {
    display: flex;
    color: #3E3E3E;
    margin-right: 25px;
  }
  #stats .stat-alarm {
    color: red !important;
  }
  #stats .stat-value {
    white-space:nowrap;
    font-size: 24px;
    line-height: 32.68px;
    font-weight: 600;
    margin-right: 3px;
    small {
      font-size: 11pt;
    }
  }
  #stats .stat-name {
    font-size: 12px;
    line-height: 16.34px;
    font-weight: 700;
  }
  @media (max-width: 600px) {
    #stats .stat-value {
      font-size: 18px;
      small {
        font-size: 11px;
      }
    }
    #stats .stat-name {
      font-size: 9px;
    }
  }
</style>

<script>

export default {
  props: ['users'],
  data() {
    return {};
  },
  computed: {
    seatLimit() {
      return (this.$store.getters.org.settings && this.$store.getters.org.settings.seatLimit) ?
        this.$store.getters.org.settings.seatLimit : false;
    },
    stats() {
      let activeCoaches = 0;
      let activeSpeakers = 0;
      let inactiveUsers = 0;
      this._.forEach(this.uniqueUsers, (u) => {
        if (u.isOrgManager || u.isOrgAdmin) return activeCoaches++;
        let isActiveSpeaker = false;
        for (let i=0; i<u.memberships.length; i++) {
          if (u.memberships[i].roles && u.memberships[i].roles.indexOf('manager') !== -1 && u.memberships[i].membershipStatus === 'active') {
            return activeCoaches++;
          }
          if (u.memberships[i].roles && u.memberships[i].roles.indexOf('speaker') !== -1 && u.memberships[i].membershipStatus === 'active') {
            isActiveSpeaker = true;
          }
        }
        return isActiveSpeaker ? activeSpeakers++ : inactiveUsers++;
      });

      const activeSpeakerSubtext = (this.seatLimit) ? ` of ${this.seatLimit}` : null;
      const activeSpeakerStatClass = (this.seatLimit === 0 || (this.seatLimit && (this.seatLimit <= activeSpeakers))) ?
        'stat-value stat-alarm' : 'stat-value';

      return [
        { name: 'Active Coaches/Admins', value: activeCoaches, statClass: 'stat-value' },
        {
          name: 'Active Speaker Seats', value: activeSpeakers,
          subtext: activeSpeakerSubtext, statClass: activeSpeakerStatClass,
        },
        { name: 'Expired Users', value: inactiveUsers, statClass: 'stat-value' },
      ];
    },
    uniqueUsers() {
      let users = {};
      this._.forEach(this.users, (g) => {
        this._.forEach(g, (u) => {
          // Augment with the memberships
          const membership = {
            groupId: u.groupId,
            roles: u.roles,
            membershipExpires: u.membershipExpires,
            membershipPerpetual: u.membershipPerpetual,
            membershipStartDate: u.membershipStartDate,
            membershipStatus: u.membershipStatus,
          };
          let _user = (users[u.userId]) ?
            users[u.userId] : this._.cloneDeep(u);
          if (!_user.memberships) {
            _user.memberships = [];
          }
          _user.memberships.push(membership);
          if (u.isOrgManager) {
            _user.isOrgManager = true;
          }
          if (u.isOrgAdmin) {
            _user.isOrgAdmin = true;
          }

          users[_user.userId] = _user;
        });
      });

      return users;
    },
  },
};
</script>
